var _path, _path2, _path3, _path4, _mask, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperatureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5H20",
    stroke: "#F0F0F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8H20",
    stroke: "#F0F0F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11H20",
    stroke: "#F0F0F0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8C11 7.72386 10.7761 7.5 10.5 7.5C10.2239 7.5 10 7.72386 10 8V15.05C8.85888 15.2816 8 16.2905 8 17.5C8 18.8807 9.11929 20 10.5 20C11.8807 20 13 18.8807 13 17.5C13 16.2905 12.1411 15.2816 11 15.05V8Z",
    fill: "#F0F0F0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_63_770",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 2C8.567 2 7 3.567 7 5.5V13.2572C5.7785 14.266 5 15.7921 5 17.5C5 20.5376 7.46243 23 10.5 23C13.5376 23 16 20.5376 16 17.5C16 15.7921 15.2215 14.266 14 13.2572V5.5C14 3.567 12.433 2 10.5 2Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.2572L8.27356 14.7993L9 14.1993V13.2572H7ZM14 13.2572H12V14.1993L12.7264 14.7993L14 13.2572ZM9 5.5C9 4.67157 9.67157 4 10.5 4V0C7.46243 0 5 2.46243 5 5.5H9ZM9 13.2572V5.5H5V13.2572H9ZM7 17.5C7 16.4138 7.49238 15.4444 8.27356 14.7993L5.72644 11.7151C4.06462 13.0875 3 15.1703 3 17.5H7ZM10.5 21C8.567 21 7 19.433 7 17.5H3C3 21.6421 6.35786 25 10.5 25V21ZM14 17.5C14 19.433 12.433 21 10.5 21V25C14.6421 25 18 21.6421 18 17.5H14ZM12.7264 14.7993C13.5076 15.4444 14 16.4138 14 17.5H18C18 15.1703 16.9354 13.0875 15.2736 11.7151L12.7264 14.7993ZM12 5.5V13.2572H16V5.5H12ZM10.5 4C11.3284 4 12 4.67157 12 5.5H16C16 2.46243 13.5376 0 10.5 0V4Z",
    fill: "#F0F0F0",
    mask: "url(#path-5-inside-1_63_770)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureIcon);
export default __webpack_public_path__ + "static/media/Temperature Icon.6ef920ca0e1c8e402f7d704ec719da53.svg";
export { ForwardRef as ReactComponent };